const valorMaximoDeString = 30;
const indiceInicial = 0;
class stringHelper {
    FormatarMoedaPadraoBrasileiro(valorBruto) {
		return valorBruto.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
	}
	FormatarStringCompridaComReticencias(string){
		return string.length > valorMaximoDeString ?
		 string.substring(indiceInicial, valorMaximoDeString) + '... ' : string;
	}
	FormatarNumeroDoCelular(telefone){
		if(telefone.length === 9)
			return `${telefone.substr(0,5)}-${telefone.substr(5,4)}`
		return telefone;
	}
}

export default new stringHelper;